import CardsList from 'components/card/CardsList';
import { withTabBackButton, WithTabBackButtonStateProps } from 'components/tab';
import React from 'react';
import { PuckDewarContainerView } from '../puck/constants';
import { Puck, PuckCardTemplateProps } from './cardTemplates';
import { useAttachSidePanelBackButton } from './hooks';
import {
  getCrystalsByPuckId,
  getFirstAvailablePinOfPuck,
  getOccupiedPinsOfCurrentPuck,
  getUpdatedCrystalsAfterCrystalContainerAssignments,
} from './utils';
import { CrystalDataDTO } from '../constants';
import { useAllPucks, useSelectedCrystalId } from 'redux/hooks/synchrotron';
import { setIsCrystalAssignmentsDirty } from 'redux/reducers/synchrotronTripReducer';
import { useRMDispatch } from 'redux/hooks';
interface Props extends WithTabBackButtonStateProps {
  setContentView?: (contentView: PuckDewarContainerView) => void;
  crystals: CrystalDataDTO[];
  setCrystals: React.Dispatch<React.SetStateAction<CrystalDataDTO[]>>;
}
const SelectPuck = (props: Props) => {
  const { setContentView, crystals, setCrystals, setHandleOnTabBackPress } = props;

  const selectedCrystalId = useSelectedCrystalId();
  const dispatch = useRMDispatch();
  const pucks = useAllPucks();

  const puckCards: Array<PuckCardTemplateProps> = pucks.map((puck) => {
    const crystalsOfSelectedPuck = getCrystalsByPuckId(crystals, puck.id);
    return {
      name: puck.name,
      barcode: puck.barcode,
      puckType: `${puck.puckType?.name} Type`,
      available: puck.pinCount - crystalsOfSelectedPuck.length,
      pinCount: puck.pinCount,
      onPuckCardClickHandler: () => {
        puckSelectHandler(puck);
      },
    };
  });

  useAttachSidePanelBackButton(
    setHandleOnTabBackPress,
    setContentView,
    PuckDewarContainerView.PuckDewarInfoView,
  );

  const puckSelectHandler = (selectedPuck) => {
    const occupiedPins = getOccupiedPinsOfCurrentPuck(selectedPuck?.id, crystals);
    const availablePinPosition = getFirstAvailablePinOfPuck(
      occupiedPins,
      selectedPuck?.pinCount,
    );

    const updatedCrystals = getUpdatedCrystalsAfterCrystalContainerAssignments(
      crystals,
      selectedCrystalId,
      {
        puckId: selectedPuck?.id,
        puckPinPosition: availablePinPosition,
        isDirty: true,
      },
    );
    setCrystals(updatedCrystals);
    setContentView(PuckDewarContainerView.PuckDewarInfoView);
    setHandleOnTabBackPress(null);
    dispatch(setIsCrystalAssignmentsDirty(true));
  };

  return (
    <div
      id="puckdewarcontainer-selectpuck-wrapper"
      className="flex flex-col w-full h-full pb-2"
    >
      <CardsList cardContent={puckCards} cardTemplate={Puck} />
    </div>
  );
};

export default withTabBackButton(SelectPuck);
